/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Tool_LimitInputs */



/**
* | output |
* | --- |
* | "The AI reached the maximum number of tool calls for this message." |
*
* @param {Chat_Error_Tool_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_tool_limit = /** @type {((inputs?: Chat_Error_Tool_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Tool_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die KI hat die maximale Anzahl an Tool-Aufrufen für diese Nachricht erreicht.")
	return /** @type {LocalizedString} */ ("The AI reached the maximum number of tool calls for this message.")
});